/**
 * Cart drawer - compact, always-visible checkout bar.
 *
 * Horizon renders the recommendations carousel, the discount accordion, the
 * totals and the checkout button together inside .cart-drawer__summary, and
 * cart-drawer.js only makes that summary sticky when it is less than half the
 * drawer height. That is why the checkout button scrolled away.
 *
 * This script keeps the summary small enough to stay pinned without scrolling:
 *   1. Removes <cart-recommendations> entirely (drawer and cart page).
 *   2. Moves the discount / cart-note block (.cart-actions) out of the summary
 *      and into the scrolling product list.
 *   3. Forces cart-summary-sticky="true" on the drawer dialog.
 *
 * The cart drawer re-renders (morphs) on every cart change, which restores the
 * stock markup, so a MutationObserver re-applies all three.
 */
(function () {
  if (window.__cartDrawerStickySummary) return;
  window.__cartDrawerStickySummary = true;

  var busy = false;

  function removeRecommendations() {
    var nodes = document.querySelectorAll('cart-recommendations');

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.parentNode) node.parentNode.removeChild(node);
    }
  }

  function moveDiscountToList() {
    var summaries = document.querySelectorAll('.cart-drawer__summary');

    for (var i = 0; i < summaries.length; i++) {
      var summary = summaries[i];
      var actions = summary.querySelector('.cart-actions');
      if (!actions) continue;

      var content = summary.closest('.cart-drawer__content');
      var items = content ? content.querySelector('.cart-drawer__items') : null;
      if (!items) continue;

      try {
        items.appendChild(actions);
      } catch (e) {
        /* ignore */
      }
    }
  }

  function keepSticky() {
    var dialogs = document.querySelectorAll('.cart-drawer__dialog');

    for (var i = 0; i < dialogs.length; i++) {
      var dialog = dialogs[i];

      // Empty cart has no summary - leave the theme's own value alone.
      if (!dialog.querySelector('.cart-drawer__summary')) continue;

      if (dialog.getAttribute('cart-summary-sticky') !== 'true') {
        dialog.setAttribute('cart-summary-sticky', 'true');
      }
    }
  }

  function apply() {
    if (busy) return;
    busy = true;

    try {
      removeRecommendations();
      moveDiscountToList();
      keepSticky();
    } catch (e) {
      /* ignore */
    }

    busy = false;
  }

  function init() {
    apply();

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(apply);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['cart-summary-sticky'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
